import React from "react";
import OurTeamSection from "../../Sections/OurTeamSection/Content";
const OurTeamPage = () => {
  return <OurTeamSection />;
};

export default OurTeamPage;
